/**
 * websiteOperationBtnsModule
 * description: 网站渠道下操作按钮
 * author: Qian.qianchen 2019-03-21
 */
'use strict';
angular.module('websiteOperationBtnsModule', []).directive('websiteOperationBtns', ['modalDialog', 'trsHttpService', 'sensitiveWordCheckService', 'websiteService', '$filter', 'trsspliceString', 'newMediaService', 'websiteConst', function (modalDialog, trsHttpService, sensitiveWordCheckService, websiteService, $filter, trsspliceString, newMediaService, websiteConst) {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: './editingCenter/iWo/fusionPending/directive/websiteOperationBtns/websiteOperationBtns_tpl.html',
        scope: {
            selectedArr: '=',
            callback: '&'
        },
        link: function ($scope, iElement, attrs) {
            initStatus();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.newOperationParams = {
                    serviceid: 'mlf_fusion',
                    methodname: 'doActionOnMediaTypeAndDocIdsSync',
                    oprType: 'daibian',
                    actionKey: '',
                    // mediaTypeDocIds: [],
                    // OprTime: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    // OprTimeStart: '',
                    // OprTimeEnd: '',
                };
                $scope.status = {
                    signedSuccess: false
                };
                $scope.data = {
                    trench: 'Fusion',
                };
                $scope.requestData = $scope.callback;
            }

            /** * 网站操作 start ***/
            /**
             * [directSignForWebsite description] 网站直接签发
             * @return {[type]} [description]
             */
            $scope.directSignForWebsite = function () {
                var param = trsspliceString.spliceString($scope.selectedArr,
                    'CHNLDOCID', ',');
                sensitiveWordCheckService.SensitiveWordsAndCareful($scope.selectedArr, '', 2).then(function () {
                    $scope.status.signedSuccess = true;
                    directSignForWebsite(param);
                }, function () {
                    modalDialog.confirmModal('签发', '确认直接签发?', function () {
                        directSignForWebsite(param);
                    });
                });
            };

            /**
             * [directSign description] 网站直接签发函数
             * @param  {[type]} chnldocIDs [description] 稿件id
             * @return {[type]}            [description]
             */
            function directSignForWebsite(chnldocIDs) {
                // var params = {
                //     serviceid: 'mlf_websiteoper',
                //     methodname: 'webDaiBianPublish',
                //     ObjectIds: chnldocIDs,
                //     ChnlDocIds: chnldocIDs
                // };
                dealOperParams();
                $scope.newOperationParams.actionKey = 'qianfa';
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'post', true).then(function (data) {
                    modalDialog.alertType('签发成功', '', 'success', false, function () {
                        $scope.callback();
                        $scope.status.signedSuccess = false;
                    });
                }, function (data) {
                    websiteService.afterSigning(data, 'webDaiBianPublish').then(function () {
                        $scope.callback();

                        $scope.status.signedSuccess = false;
                    }, function () {
                        $scope.callback();

                        $scope.status.signedSuccess = false;
                    });
                });
            }

            /**
             * [timeSignForWebsite description] 网站定时签发
             * @return {[type]} [description]
             */
            $scope.timeSignForWebsite = function () {
                var param = $scope.selectedArr;
                sensitiveWordCheckService.SensitiveWordsAndCarefulTiming($scope.selectedArr).then(function () { }, function () {
                    timeSignForWebsite(param);
                });
            };

            /**
             * [timeSign description] 网站定时签发函数
             * @param  {[type]} items [description] 选中的稿件数组
             * @return {[type]}       [description]
             */
            function timeSignForWebsite(items) {
                // var params = {
                //     selectedArray: items,
                //     isNewDraft: false,
                //     methodname: 'webDaiBianTimingPublish'
                // };
                // dealOperParams();
                // $scope.newOperationParams.selectedArray = items;
                // $scope.newOperationParams.actionKey = 'dingshiqianfa';
                // $scope.loadingPromise = editingCenterService.draftTimeSinged($scope.newOperationParams).then(function (data) {
                //     modalDialog.alertType('定时签发成功', '', 'success', false);
                //     $scope.callback();
                // }, function (data) {
                //     data.REPORTS = angular.isDefined(data.reports) ? data.reports : data;
                //     websiteService.afterSigning(data, 'webDaiBianTimingPublish', true).then(function () {
                //         $scope.callback();

                //     }, function () {
                //         $scope.callback();

                //     });
                //     $scope.callback();

                // });
                $scope.requestData = $scope.callback;
                $scope.data.selectedArray = $scope.selectedArr;
                $scope.loadingPromise = newMediaService.timeSign($scope, websiteConst.daibianTimeSign, signCallBack);
            }

            /**
             * [signCallBack description] 签发回调, 主要是强制签发时组装参数
             * @param   {[type]}  params  [params description]
             * @param   {[type]}  array   [array description]
             * @return  {[type]}          [return description]
             */
            function signCallBack(params, array) {
                var ChnlDocIds = [];
                var ObjectIds = [];
                var MetaDataIds = [];
                for (var i = 0; i < array.length; i++) {
                    ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                    ObjectIds.push(array[i].DOC.CHNLDOCID);
                    MetaDataIds.push(array[i].DOC.METADATAID);
                }
                params.ChnlDocIds = ChnlDocIds.join(',');
                params.ObjectIds = ObjectIds.join(',');
                params.MetaDataIds = MetaDataIds.join(',');
            }

            /**
             * [trialForWebsite description] 网站送审
             * @return {[type]} [description]
             */
            $scope.trialForWebsite = function () {
                $scope.newOperationParams.actionKey = 'songshen';
                $scope.data.selectedArray = $scope.selectedArr;
                $scope.loadingPromise = newMediaService.trial($scope, $scope.newOperationParams);
            };

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function dealOperParams() {
                $scope.newOperationParams.mediaTypeDocIds = [];
                $scope.selectedArr.forEach((item) => {
                    $scope.newOperationParams.mediaTypeDocIds.push({
                        MEDIATYPE: item.MEDIATYPE,
                        DOCID: item.METADATAID
                    });
                });
                $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
            }

            /**
             * [selectedChannelId description]过滤器过滤移动稿件CHANNELID不相同的情况
             * @param  {[type]} elm [description]传入的值
             * @return {[type]}     [description]
             */
            $scope.filterChannelId = function (elm) {
                if (angular.isDefined(elm.CHANNELID)) {
                    return elm.CHANNELID == $scope.selectedArr[0].CHANNELID;
                }
            };

            /** * 网站操作 end ***/
        }
    };
}]);
